<!-- prettier-ignore -->
@for (part of parts; track part) {
  <span [class.highlight]="part.highlight" [style.color]="part.highlight ? color : null">{{ part.text }}</span>
}
